import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';
import { BrowserLocaleInfo, getBrowserLocaleInfo } from '../settings/languageRegion/browserLocaleInfo';

export const browserDefaultsAtom = atom<BrowserLocaleInfo>({
	language: '',
	timezone: '',
	dateFormat: '',
	currency: '',
	firstDayOfWeek: 'monday',
});

export const useBrowserLocale = (): BrowserLocaleInfo => {
	const [browserLocale, setBrowserLocale] = useAtom(browserDefaultsAtom);
	useEffect(() => {
		const get = async () => {
			const result = await getBrowserLocaleInfo();
			setBrowserLocale(result);
			return result;
		};

		get();
	}, [setBrowserLocale]);

	return browserLocale;
};
